import React, { useState } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';

import csrfObject from '../modules/csrf';

const propTypes = {
  dir: PropTypes.string,
  endpoint: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

const StepProgressButton = ({ dir = null, endpoint, text }) => {
  const [busy, setBusy] = useState(false);
  const handleClick = () => {
    setBusy(true);
    $.post(endpoint, csrfObject())
      .done(({ nextUrl }) => {
        window.location = nextUrl;
      });
  };

  return (
    <button
      className="lesson__button"
      data-test="stepProgressButton"
      dir={dir}
      disabled={busy}
      onClick={handleClick}
      type="button"
    >
      {text}
    </button>
  );
};

StepProgressButton.propTypes = propTypes;

export default StepProgressButton;
